var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('error-group',{attrs:{"validator":_vm.validations,"name":"field"}},[_c('v-select',{attrs:{"label":_vm.field.label,"value":_vm.value,"items":_vm.field.options,"disabled":_vm.readonly,"multiple":"","chips":"","deletable-chips":"","menu-props":{ openOnHover: true },"color":"#005c7b"},on:{"change":_vm.onChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }